module.exports = __webpack_public_path__ + "img/top_22.644cb18e.png";